import { anyType, booleanType, someType, stringType } from '../_util/type';
export const flexProps = () => ({
    prefixCls: stringType(),
    vertical: booleanType(),
    /** flex-wrap CSS value, or boolean shortcut (antd ≥ 5.17). */
    wrap: someType([Boolean, String]),
    justify: stringType(),
    align: stringType(),
    flex: someType([Number, String]),
    gap: someType([Number, String]),
    component: anyType(),
});
